import React, { useEffect, useState } from "react";
import IconMetaMask from "../../assets/img/icon-metamask.svg";
import IconWalletConnect from "../../assets/img/icon-wallet-connect.svg";
import algorandIcon from "../../assets/ms-new-images/Algorand-logo.svg";
import { FDialog, FList, FListItem, FButton } from "ferrum-design-system";
import { SelectWalletAddressDialog } from "../../components/bridge/components/select-wallet-address/SelectWalletAddressDialog";
import { RiSwapLine } from "react-icons/ri";
import { useAlgoSignerWalletConnector, useWalletConnector } from "foundry";

export const ConnectWalletDialog = ({
  show,
  onHide,
  metaMaskClickEvent,
  zerionClickEvent,
  walletConnectClickEvent,
  algorandWalletClickEvent,
  selectAlgorandWalletAddress,
}: any) => {
  const [showAlgoDialog, setShowAlgoWalletDialog] = useState<any>(false);
  const {
    isConnected,
    isConnecting,
    currentWallet,
    walletAddress,
    resetWalletConnector,
  } = useWalletConnector();
  const { isAlgoConnected, isAlgoConnecting, walletAddresses } =
    useAlgoSignerWalletConnector();

  useEffect(() => {
    if (isAlgoConnected && walletAddresses && walletAddresses?.length) {
      selectAlgorandWalletAddress(walletAddresses[0]?.address);
    }
    if (!walletAddress) {
      resetWalletConnector();
    }
    // eslint-disable-next-line
  }, [walletAddresses]);

  return (
    <>
      <FDialog
        show={show}
        onHide={onHide}
        size="medium"
        variant="futuristic-primary"
        className="dialog-connect-wallet text-center"
      >
        <FList display="block" type="number" variant="connect-wallet">
          <FListItem display="flex">
            <span className="icon-wrap">
              <img src={IconMetaMask} alt={IconMetaMask}></img>
            </span>
            <strong>MetaMask</strong>
            <FButton
              title={
                isConnected && currentWallet === "MetaMask"
                  ? "Disconnect"
                  : isConnecting && currentWallet === "MetaMask"
                  ? "Connecting"
                  : "Connect"
              }
              onClick={metaMaskClickEvent}
              disabled={isConnecting}
            />
          </FListItem>
          <FListItem display="flex">
            <span className="icon-wrap">
              <img src={algorandIcon} alt={algorandIcon} sizes={"100"}></img>
            </span>
            <strong>AlgoSigner</strong>
            {isAlgoConnected ? (
              <FButton
                title=""
                variant="primary"
                postfix={<RiSwapLine />}
                onClick={() => {
                  setShowAlgoWalletDialog(true);
                  onHide();
                }}
              />
            ) : null}
            <FButton
              title={
                isAlgoConnected
                  ? "Disconnect"
                  : isAlgoConnecting
                  ? "Connecting"
                  : "Connect"
              }
              onClick={algorandWalletClickEvent}
              disabled={isAlgoConnecting}
            />
          </FListItem>
          <FListItem display="flex">
            <span className="icon-wrap">
              <img src={IconWalletConnect} alt={IconWalletConnect}></img>
            </span>
            <strong>WalletConnect</strong>
            <FButton
              title={
                isConnected && currentWallet === "WalletConnect"
                  ? "Disconnect"
                  : isConnecting && currentWallet === "WalletConnect"
                  ? "Connecting"
                  : "Connect"
              }
              onClick={walletConnectClickEvent}
              disabled={isConnecting}
            />
          </FListItem>
        </FList>
        <FButton onClick={onHide} className="f-mt-1" title={"Close"} />
      </FDialog>
      <SelectWalletAddressDialog
        show={showAlgoDialog}
        onHide={() => setShowAlgoWalletDialog(false)}
        selectAlgorandWalletAddress={selectAlgorandWalletAddress}
      />
    </>
  );
};
